<div class="error-overlay" [class.error-overlay--visible]="!!message">
  <div class="error-card" role="alert" aria-live="assertive">
    <div class="error-card__icon" aria-hidden="true"></div>
    <div class="error-card__content">
      <div class="error-card__title">No pudimos cargar el historial</div>
      <div class="error-card__message">{{ getTruncatedMessage() }}</div>
      <div class="error-card__actions">
        <button class="btn btn--primary" (click)="onRetry()">
          Reintentar con otra fecha
        </button>
        <button class="btn btn--ghost" (click)="onClose()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
